import { EXPERIMENT_NAME_AA } from '../../common/utils/constants';
import {
	setHasSeenFirstModalAA,
	setHasSeenFirstModalAB,
	setHasSeenUrgentModalAA,
	setHasSeenUrgentModalAB,
} from '../../common/utils/local-storage';

export const setHasSeenModal = (expermientName: string, isUrgent: boolean) => {
	if (expermientName === EXPERIMENT_NAME_AA) {
		isUrgent ? setHasSeenUrgentModalAA() : setHasSeenFirstModalAA();
	} else {
		isUrgent ? setHasSeenUrgentModalAB() : setHasSeenFirstModalAB();
	}
};
